
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Seatings, { RoomState } from '@/services/Seatings'
import videos, { Video, VideoList } from '@/services/Videos'

@Component
export default class VideoSelect extends Vue {
  @Prop({ default: null }) public videoId!: string | null
  @Prop({ default: false }) public disabled!: boolean

  public restaurantId: string = ''
  public selectedVideo: string | null = this.videoId
  public roomState: RoomState | null = null

  public videosList: Video[] = []

  public created() {
    this.restaurantId = this.$route.params.restaurantId

    videos.observeVideos(this.restaurantId, videosList => {
      this.videosList = videosList
    })
  }

  @Watch('videoId')
  receivingVideoId(val: string | null) {
    this.selectedVideo = val
  }

  public change() {
    this.$emit('change', this.selectedVideo)
  }
}
